<cac-dialog-layout title="ادیت پروفایل" (onSubmit)="onSubmit($event)" cancelBtn="لغو" submitBtn="ذخیره">
  <cac-form-builder [options]="userForm" class="mt-6 mb-8"></cac-form-builder>
  <cac-button (onClick)="onToggleChangePassword()" appearance="stroked" class="w-fit">{{changePasswordMode() ? 'عدم تغییر پسورد' : 'تغییر پسورد'}}</cac-button>
    @if(changePasswordMode()) {
        <cac-form-builder [options]="PasswordForm" class="mt-8"></cac-form-builder>
    }
</cac-dialog-layout>